import React from 'react';
import { isNil } from 'lodash';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import Anchor from '../../../../../components/link/Anchor';
import { openNewWindow, setDetailPageUrl } from '../../../../../lib/common';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import OpenPreviewTagDetail from '../../../../../containers/app/common/OpenPreviewTagDetail';
import Tag from '../../../../../components/tag/Tag/Tag';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { Columns } from '../../../../../types/common/table';
import { TagGroupItemV2, TagItemV2 } from '../../../../../types/tag';
import RelatedTagButton from './RelatedTagButton';
import { WidgetTagFilterOption } from '../../../../../types/widget';
import { TAG_STATUS_V2, TAG_STATUS_V2_TEXT } from '../../../../../constants/service/app/tagConstants';
import { ValueOf } from '../../../../../types/common/utils';

export const tagReactTableColumns: Columns<TagItemV2, WidgetTagFilterOption> = (data) => {
  const sortable = !!Object.keys(data).length;
  const { filterOption, onFilter } = data;

  return [
    {
      accessor: 'url',
      Header: '이미지',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} width={'60px'} height={'60px'} />,
    },
    {
      accessor: 'id',
      Header: '태그 ID',
      filterable: !!filterOption,
      Cell: (row) => (
        <Anchor
          text={row.value}
          isUnderLine
          color="primary"
          onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, row.value))}
        />
      ),
      Filter: () => (
        <TableFilterInput
          type="number"
          option={filterOption.id}
          onFilter={(id: string): void => onFilter({ id: isNil(id) ? id : Number(id) })}
        />
      ),
    },
    {
      accessor: 'name',
      Header: '태그명',
      filterable: !!filterOption,
      Cell: (row) => <OpenPreviewTagDetail text={row.value} tagId={row.original.id} />,
      Filter: () => <TableFilterInput option={filterOption.name} onFilter={(name: string) => onFilter({ name })} />,
    },
    {
      accessor: 'status',
      Header: '태그 상태',
      Cell: (row) => TAG_STATUS_V2_TEXT[row.value as ValueOf<typeof TAG_STATUS_V2>],
    },
    {
      accessor: 'tagGroupList',
      Header: '태그 그룹',
      Cell: (row) =>
        row.value && row.value.length
          ? row.value.map((tagGroup: TagGroupItemV2, index: number) => (
              <Tag key={index} text={tagGroup.name} isAddHash={false} />
            ))
          : '-',
    },
    {
      id: 'relatedTagList',
      Header: '연관된 태그',
      accessor: 'relatedTagList',
      Cell: (row) => <RelatedTagButton tagId={row.original.id} />,
    },
    {
      accessor: 'createDate',
      Header: '생성일',
      sortable,
      minWidth: 120,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};
